const permissions = {
  listTemplate: 'CC001',
  editTemplate: 'CC003',
  addTemplate: 'CC002',
  deleteTemplate: 'CC004'
};

export default permissions;
